export default "__VITE_ASSET__DWLIR$0q__"